import { LogoutApi } from "./logoutApiCall";
import getApiCall from "./getApiCall";
import { slugifyTransform } from "../Utils/Helpers";
export async function Logout() {
    // confirm the user wants to logout
    if (window.confirm("Are you sure you want to logout?")) {
       const response= await LogoutApi("logoutButton")
       if(response){
       const accountKey = localStorage.getItem('allAccounts');
       const savedAllAccount_cleanup_v1 = localStorage.getItem('savedAllAccount_cleanup_v1');
       const selectedPartner = JSON.parse(localStorage.getItem('selectedPartner'));
            localStorage.clear();

            if (accountKey) {
                localStorage.setItem('allAccounts', accountKey);
                 localStorage.setItem('savedAllAccount_cleanup_v1', savedAllAccount_cleanup_v1);
                // localStorage.setItem('selectedPartner', JSON.stringify({name:selectedPartner?.name}));
            }
 window.location.replace(`/${slugifyTransform(selectedPartner?.name)}`);
        }
    }

}

export async function RemoveKeysFromLocalStorage() {

    const accountKey = localStorage.getItem('allAccounts');
    const selectedPartner = JSON.parse(localStorage.getItem('selectedPartner'));
    const savedAllAccount_cleanup_v1 = localStorage.getItem('savedAllAccount_cleanup_v1');
    localStorage.clear();

    if (accountKey) {
        localStorage.setItem('allAccounts', accountKey);
         localStorage.setItem('savedAllAccount_cleanup_v1', savedAllAccount_cleanup_v1);
        // localStorage.setItem('selectedPartner', JSON.stringify({name:selectedPartner?.name}));
    }
    window.location.replace(`/${slugifyTransform(selectedPartner?.name)}`);

}

export function userDetails() {
    let data = localStorage.getItem('userDetails');
    data = JSON.parse(data);
    return data;
}
export function selectedPartnerDetails() {
    let data = localStorage.getItem('selectedPartner');
    data = JSON.parse(data);
    return data;
}
export async function permissonTypeList() {
    let responseData = await getApiCall('admin/configuration/details/permissionTypes');
    let data = []
    if (responseData.meta.status) {
        data = responseData.data
    }
    console.log('responseData::::::',responseData)
    return data;
}
